// extracted by mini-css-extract-plugin
module.exports = {"mobileFilter":"styles_mobileFilter__-m7Jg","content":"styles_content__RUctA","footer":"styles_footer__BjiqB"};